module.exports = "././img/client_logo.png";


//////////////////
// WEBPACK FOOTER
// ../assets/wa/img/client_logo.png
// module id = 828
// module chunks = 0